const InvalidRefSymbol = Symbol();
/**
 * Проверяет совместимость ref и приводит тип для передачи в элемент.
 * @example
 * ```ts
 * // -- Пример 1
 * const ref = useRef<HTMLLIElement>(null);
 * // ошибка
 * <div ref={castRef(ref, 'div')} />
 * // ок
 * <li ref={castRef(ref, 'li')} />
 * // -- Пример 2
 * // Общий тип позволяет избежать ошибок при работе с ref:
 * // нельзя обратиться к полям конкретной реализации без тайпгарда.
 * const ref2 = useRef<HTMLElement>(null);
 * // ок
 * <div ref={castRef(ref, 'div')} />
 * // ок
 * <li ref={castRef(ref, 'li')} />
 * ```
 * @param ref ref для проверки
 * @param _tag тег, для которого передается ref, например: 'div', 'li', 'a'
 * @returns ref требуемого типа
 */
export function castRef(ref, _tag) {
    if (!ref) {
        return ref;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return ref;
}
